import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1 text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary" }, "Confirmar sobrescrita", -1)
const _hoisted_3 = {
  class: "text-sm text-neutral50",
  "data-testid": "leg-overwrite-subtitle"
}
const _hoisted_4 = { class: "flex flex-col gap-4 text-left" }
const _hoisted_5 = {
  key: 0,
  class: "rounded border border-primary bg-primary5 px-3 py-2 text-sm text-textPrimary",
  role: "status",
  "data-testid": "leg-overwrite-stale-notice"
}
const _hoisted_6 = ["data-testid"]
const _hoisted_7 = { class: "flex flex-wrap items-center gap-2 border-b border-gray-30 px-3 py-2 text-sm" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "text-gray-500" }
const _hoisted_10 = ["data-testid"]
const _hoisted_11 = { class: "block w-full text-sm sm:table" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", { class: "hidden sm:table-header-group" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-left text-xs uppercase text-gray-500" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 font-bold" }, "Perna"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 font-bold" }, "Registro atual"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 font-bold" }, "Este registro"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-3 py-2 font-bold" }, "Qual vale")
  ])
], -1)
const _hoisted_13 = { class: "block sm:table-row-group" }
const _hoisted_14 = ["data-testid"]
const _hoisted_15 = { class: "col-span-2 px-3 pb-0 pt-2 font-semibold sm:table-cell sm:py-2" }
const _hoisted_16 = { class: "min-w-0 px-3 py-2 sm:table-cell" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs uppercase text-gray-500 sm:hidden" }, "Registro atual", -1)
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = { class: "text-xs text-gray-500" }
const _hoisted_20 = { class: "min-w-0 px-3 py-2 sm:table-cell" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "block text-xs uppercase text-gray-500 sm:hidden" }, "Este registro", -1)
const _hoisted_22 = ["data-testid"]
const _hoisted_23 = {
  key: 1,
  class: "block text-xs text-gray-500"
}
const _hoisted_24 = { class: "col-span-2 px-3 pb-3 pt-0 sm:table-cell sm:py-2" }
const _hoisted_25 = ["aria-label"]
const _hoisted_26 = ["aria-pressed", "disabled", "data-testid", "onClick"]
const _hoisted_27 = ["data-testid"]
const _hoisted_28 = { class: "font-semibold text-orange-800" }
const _hoisted_29 = ["data-testid"]
const _hoisted_30 = ["data-testid"]
const _hoisted_31 = { key: 2 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-500" }, " Confira o valor antes de confirmar: a sobrescrita pode mudar o que entra no pagamento. ", -1)
const _hoisted_33 = ["data-testid"]
const _hoisted_34 = {
  key: 1,
  class: "flex flex-col gap-1"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  for: "leg-overwrite-justification",
  class: "text-sm font-semibold text-textPrimary"
}, " Justificativa da sobrescrita (obrigatória) ", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-500" }, " Obrigatória porque algum horário muda com a sobrescrita. ", -1)
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 2,
  class: "text-sm text-negative",
  role: "alert",
  "data-testid": "leg-overwrite-error"
}
const _hoisted_39 = { class: "flex flex-col gap-3 sm:flex-row sm:justify-end" }

import { computed, ref, watch } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import type { DSAttendanceLegOverwritePayload } from '@/Network/Types/Requests/DsAttendanceRequest'
import type { EffectiveValueStatus } from '../composables/useLegOverwriteApproval'
import type {
  EffectiveValue,
  LegKey,
  LegOverwriteChoice,
  LegOverwriteConflict
} from '@/Network/Types/Responses/DsAttendanceLegOverwriteResponses'
import { toDDMMYYYY } from '../utils/activity-time'
import {
  LEG_LABELS,
  PRIORITY_PAYMENT_LABELS,
  RECORD_KIND_LABELS,
  buildDefaultDecisions,
  buildLegOverwritesPayload,
  canConfirmLegOverwrite,
  choiceOf,
  effectiveValueSummary,
  formatLegTime,
  hasInvalidLegCombination,
  priorityPaymentSummary,
  requiresAnyJustification,
  type DecisionsByStation
} from '../utils/leg-overwrite'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceLegOverwriteModal',
  props: {
    modelValue: { type: Boolean },
    conflicts: {},
    effectiveValues: { default: () => ({}) },
    effectiveValueStatus: { default: () => ({}) },
    submitting: { type: Boolean, default: false },
    errorMessage: { default: null },
    staleNotice: { type: Boolean, default: false }
  },
  emits: ["confirm", "decisionsChange", "cancel"],
  setup(__props: any, { emit }) {

const props = __props;

/**
 * Spec 2026-09-24 §8.1 — "Confirmar sobrescrita". Componente burro: recebe os conflitos da
 * prévia (ou do 409 de corrida), emite o corpo `legOverwrites` e avisa (`decisionsChange`)
 * quando as decisões mudam num plantão com pagamento prioritário — o composable rechama a
 * prévia e devolve o valor exato em `effectiveValues` (D-W5). Regras em `utils/leg-overwrite.ts`.
 */




const CHOICE_OPTIONS: Array<{ value: LegOverwriteChoice; label: string; testId: string }> = [
  { value: 'NEW', label: 'Este registro', testId: 'new' },
  { value: 'KEEP', label: 'Manter atual', testId: 'keep' }
]

const decisions = ref<DecisionsByStation>({})
const justification = ref('')

// D-W2: conflitos novos (abertura ou 409 de corrida) voltam ao default; a justificativa fica.
watch(
  () => props.conflicts,
  (conflicts) => {
    decisions.value = buildDefaultDecisions(conflicts)
  },
  { immediate: true }
)

// Cada abertura é uma aprovação nova: nada da anterior fica digitado.
watch(
  () => props.modelValue,
  (open, wasOpen) => {
    if (open && !wasOpen) justification.value = ''
  }
)

const hasPriorityPayment = computed(() =>
  props.conflicts.some((conflict) => conflict.priorityPayment)
)

function currentChoice(conflict: LegOverwriteConflict, leg: LegKey): LegOverwriteChoice {
  return choiceOf(decisions.value[conflict.doctorStationId], leg)
}

function choose(conflict: LegOverwriteConflict, leg: LegKey, choice: LegOverwriteChoice) {
  if (currentChoice(conflict, leg) === choice) return
  decisions.value = {
    ...decisions.value,
    [conflict.doctorStationId]: { ...decisions.value[conflict.doctorStationId], [leg]: choice }
  }
  // D-W5: só o plantão com pagamento prioritário tem valor a recalcular.
  if (hasPriorityPayment.value) {
    emit('decisionsChange', buildLegOverwritesPayload(props.conflicts, decisions.value, ''))
  }
}

function effectiveValueOf(conflict: LegOverwriteConflict): EffectiveValue | null {
  return props.effectiveValues[conflict.doctorStationId] ?? conflict.effectiveValue
}

function valueStatusOf(conflict: LegOverwriteConflict): EffectiveValueStatus | undefined {
  return props.effectiveValueStatus[conflict.doctorStationId]
}

function priorityLabel(conflict: LegOverwriteConflict): string {
  const type = conflict.priorityPayment?.type
  return (type && PRIORITY_PAYMENT_LABELS[type]) || 'Pagamento prioritário'
}

const subtitle = computed(() => {
  const count = props.conflicts.length
  const lead =
    count === 1
      ? '1 plantão deste registro já tem outro registro aprovado cobrindo a mesma perna.'
      : `${count} plantões deste registro já têm outro registro aprovado cobrindo a mesma perna.`
  return `${lead} Escolha, perna a perna, qual registro vale.`
})

const justificationRequired = computed(() =>
  requiresAnyJustification(props.conflicts, decisions.value)
)

const canConfirm = computed(() =>
  canConfirmLegOverwrite(props.conflicts, decisions.value, justification.value)
)

function confirm() {
  if (!canConfirm.value || props.submitting) return
  emit('confirm', buildLegOverwritesPayload(props.conflicts, decisions.value, justification.value))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[880px]",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('cancel')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("p", _hoisted_3, _toDisplayString(subtitle.value), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_39, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "110px",
          height: "40px",
          disabled: _ctx.submitting,
          "data-testid": "leg-overwrite-cancel-button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
        }, null, 8, ["disabled"]),
        _createVNode(FilledButton, {
          text: "Confirmar sobrescrita e aprovar",
          class: "bg-primary30",
          width: "280px",
          height: "40px",
          disabled: !canConfirm.value || _ctx.submitting,
          "data-testid": "leg-overwrite-confirm-button",
          onClick: confirm
        }, null, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.staleNotice)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Os registros deste plantão mudaram — revise as escolhas antes de confirmar. "))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conflicts, (conflict) => {
          return (_openBlock(), _createElementBlock("article", {
            key: conflict.doctorStationId,
            class: _normalizeClass(["rounded border", conflict.frozen ? 'border-negative bg-red-50' : 'border-gray-30 bg-white']),
            "data-testid": `leg-overwrite-station-${conflict.doctorStationId}`
          }, [
            _createElementVNode("header", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(conflict.doctorName), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(conflict.stationLabel) + " · " + _toDisplayString(_unref(toDDMMYYYY)(conflict.stationDate)), 1),
              (conflict.priorityPayment)
                ? (_openBlock(), _createBlock(LabelBadge, {
                    key: 0,
                    label: priorityLabel(conflict),
                    color: "orange",
                    size: "small",
                    icon: null
                  }, null, 8, ["label"]))
                : _createCommentVNode("", true),
              (conflict.frozen)
                ? (_openBlock(), _createBlock(LabelBadge, {
                    key: 1,
                    label: "Pós-plantão aprovado",
                    color: "red",
                    size: "small",
                    icon: null
                  }))
                : _createCommentVNode("", true)
            ]),
            (conflict.frozen)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: "px-3 pt-2 text-sm font-semibold text-negative",
                  "data-testid": `leg-overwrite-frozen-${conflict.doctorStationId}`
                }, " A sobrescrita está bloqueada: o pós-plantão deste plantão já foi aprovado. Reabra o pós-plantão e aprove este registro de novo. ", 8, _hoisted_10))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("tbody", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conflict.legs, (leg) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: leg.leg,
                    class: _normalizeClass(["grid grid-cols-2 border-t border-gray-30 align-top sm:table-row", leg.timeChanges ? 'bg-yellow-50' : '']),
                    "data-testid": `leg-overwrite-row-${conflict.doctorStationId}-${leg.leg}`
                  }, [
                    _createElementVNode("td", _hoisted_15, _toDisplayString(_unref(LEG_LABELS)[leg.leg]), 1),
                    _createElementVNode("td", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", null, _toDisplayString(_unref(formatLegTime)(leg.current.time, conflict.timezone)), 1),
                        _createElementVNode("span", _hoisted_19, [
                          _createTextVNode(_toDisplayString(_unref(RECORD_KIND_LABELS)[leg.current.kind] ?? leg.current.kind) + " #" + _toDisplayString(leg.current.containerId), 1),
                          (leg.current.pinned)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · perna fixada")
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("span", {
                        class: _normalizeClass(leg.timeChanges ? 'font-bold text-amber-800' : '')
                      }, _toDisplayString(_unref(formatLegTime)(leg.incoming.time, conflict.timezone)), 3),
                      (leg.timeChanges)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "block text-xs font-semibold text-amber-800",
                            "data-testid": `leg-overwrite-time-changes-${conflict.doctorStationId}-${leg.leg}`
                          }, "horário diferente", 8, _hoisted_22))
                        : (_openBlock(), _createElementBlock("span", _hoisted_23, "mesmo horário"))
                    ]),
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("div", {
                        class: "flex w-full overflow-hidden rounded border border-primary30 sm:inline-flex sm:w-auto",
                        role: "group",
                        "aria-label": `Qual registro vale no ${_unref(LEG_LABELS)[leg.leg]}`
                      }, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(CHOICE_OPTIONS, (option) => {
                          return _createElementVNode("button", {
                            key: option.value,
                            type: "button",
                            class: _normalizeClass(["flex-1 whitespace-nowrap px-3 py-2 text-xs font-semibold sm:flex-none sm:py-1 disabled:cursor-not-allowed disabled:opacity-50", 
                      currentChoice(conflict, leg.leg) === option.value
                        ? 'bg-primary30 text-white'
                        : 'bg-white text-primary30'
                    ]),
                            "aria-pressed": currentChoice(conflict, leg.leg) === option.value,
                            disabled: conflict.frozen || _ctx.submitting,
                            "data-testid": `leg-overwrite-${conflict.doctorStationId}-${leg.leg}-${option.testId}-button`,
                            onClick: ($event: any) => (choose(conflict, leg.leg, option.value))
                          }, _toDisplayString(option.label), 11, _hoisted_26)
                        }), 64))
                      ], 8, _hoisted_25)
                    ])
                  ], 10, _hoisted_14))
                }), 128))
              ])
            ]),
            (conflict.priorityPayment)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "flex flex-col gap-1 border-t border-dashed border-alert bg-orange-50 px-3 py-2 text-sm",
                  "data-testid": `leg-overwrite-priority-${conflict.doctorStationId}`
                }, [
                  _createElementVNode("span", _hoisted_28, " Plantão com pagamento prioritário: " + _toDisplayString(_unref(priorityPaymentSummary)(conflict)) + ". ", 1),
                  (valueStatusOf(conflict) === 'PENDING')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "italic text-gray-600",
                        "data-testid": `leg-overwrite-value-pending-${conflict.doctorStationId}`
                      }, " Recalculando valor… ", 8, _hoisted_29))
                    : (valueStatusOf(conflict) === 'ERROR')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "font-semibold text-orange-800",
                          "data-testid": `leg-overwrite-value-error-${conflict.doctorStationId}`
                        }, " Não foi possível recalcular o valor desta combinação. ", 8, _hoisted_30))
                      : (_unref(effectiveValueSummary)(effectiveValueOf(conflict)))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_unref(effectiveValueSummary)(effectiveValueOf(conflict))), 1))
                        : _createCommentVNode("", true),
                  _hoisted_32
                ], 8, _hoisted_27))
              : _createCommentVNode("", true),
            (_unref(hasInvalidLegCombination)(conflict, decisions.value[conflict.doctorStationId]))
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "border-t border-gray-30 px-3 py-2 text-sm text-negative",
                  "data-testid": `leg-overwrite-invalid-${conflict.doctorStationId}`
                }, " Com essa combinação o check-out fica antes do check-in. Escolha outra combinação. ", 8, _hoisted_33))
              : _createCommentVNode("", true)
          ], 10, _hoisted_6))
        }), 128)),
        (justificationRequired.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _hoisted_35,
              _hoisted_36,
              _withDirectives(_createElementVNode("textarea", {
                id: "leg-overwrite-justification",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((justification).value = $event)),
                rows: "3",
                class: "rounded border border-gray-30 p-2 text-sm",
                disabled: _ctx.submitting,
                "data-testid": "leg-overwrite-justification-input"
              }, null, 8, _hoisted_37), [
                [_vModelText, justification.value]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})